import { Query } from "react-apollo";
import gql from "graphql-tag";
import { RouteVariable, Route, RouteOutput, RentalAdvert } from "../../../types/types";

import { Moment } from "moment";

type QueryVariables = {
  id: number
  start_date: string
  end_date: string
  max_people: number
  room_id: number
  routes: RouteVariable<RebookFormRoutes>[]
}


export type RebookFormRoutes = {
  new_conversation_booking: Route
}


export type QueryResult = {
  rentalAdvert: RentalAdvert
  routes: RouteOutput<RebookFormRoutes>[]

}

export class RebookFormQuery extends Query<QueryResult, QueryVariables> { }

export const query = () => {
  return gql`
    query Pricing($id:ID!,$start_date:ISO8601DateTime,$end_date:ISO8601DateTime,$max_people:Int,$room_id:Int,$routes:[RouteInput!]!) {
      rentalAdvert(id:$id) {
        id
        pricing(startDate:$start_date, endDate:$end_date, maxPeople: $max_people, roomId: $room_id){
          price
          priceLabel
          error
          bookingLink
          bookLabel
          withBookingModule
          extraPricingDetails
        }
      }
      routes: routes(routes: $routes) {
        url
        path
        name
        identifier
      }
    }
  `
}


export const variables = (advert_id: number, start_date: Moment, end_date: Moment, max_people: number, room_id: number, conversation_id: number) : QueryVariables => (
  {
    id: advert_id,
    start_date: start_date ? start_date.toISOString() : null,
    end_date: end_date ? end_date.toISOString() : null,
    max_people: max_people,
    room_id: room_id,
    routes: [
      {
        identifier: "new_conversation_booking",
        name: "new_conversation_booking",
        args: {
          booking: {
            arrival_date: start_date ? start_date.format("DD-MM-YYYY") : '',
            departure_date: end_date ? end_date.format("DD-MM-YYYY") : '',
          },
          conversation_id: conversation_id
        },
      }
    ]
  }
)
